import React from "react";
import { mobile, tablet } from "components/templates/Breakpoints";
import styled from "styled-components";
import { types } from "react-bricks/frontend";
import { color } from "@styles";

enum Height {
  small = "2.5rem",
  medium = "5rem",
  large = "7.5rem",
}

interface SpacerProps {
  height: Height;
  background?: types.IColor;
}

export const Spacer: types.Brick<SpacerProps> = ({ height = Height.small, background }) => {
  return <Wrapper height={height} backgroundColor={background?.color} />;
};

Spacer.schema = {
  name: "spacer",
  label: "Spacer",
  category: "Spacer Components",
  previewImageUrl: "/static/bricks/spacer.png",
  // Define repeaters for child bricks
  repeaterItems: [],
  // Define default props
  getDefaultProps: () => ({
    height: Height.small,
    background: { color: color.white },
  }),
  // Define side edit props
  sideEditProps: [
    {
      name: "height",
      label: "Spacer Height",
      shouldRefreshStyles: true,
      type: types.SideEditPropType.Select,
      selectOptions: {
        display: types.OptionsDisplay.Radio,
        options: Object.values(Height).map((value) => ({ value, label: value })),
      },
    },
    {
      name: "background",
      label: "Background Color",
      type: types.SideEditPropType.Select,
      shouldRefreshStyles: true,
      selectOptions: {
        display: types.OptionsDisplay.Color,
        options: [
          { value: { color: color.B210 }, label: "Gray" },
          { value: { color: color.white }, label: "White" },
          { value: { color: color.S3100 }, label: "Purple" },
        ],
      },
    },
  ],
};

const Wrapper = styled.div<{ height: string; backgroundColor: string }>`
  width: 100%;
  height: ${(p) => p.height};
  background: ${(p) => p.backgroundColor || color.white};

  ${tablet} {
    height: ${(p) => reduceValue(p.height, 2)};
  }

  ${mobile} {
    height: ${(p) => reduceValue(p.height, 2.5)};
  }
`;

const reduceValue = (value: string, divideBy: number) => {
  if (!value) {
    return value;
  }
  return (Number(value.replace("rem", "")) / divideBy).toFixed(2) + "rem";
};
